import { withChartLayout } from 'components/common';
import GastrointestinalAssessment from 'components/features/chart/system-assessment/gastrointestinal-assessment/GastrointestinalAssessment';

const GastrointestinalAssessmentPage = withChartLayout('Gastrointestinal Assessment')(GastrointestinalAssessment);
export default GastrointestinalAssessmentPage;
